// Keep the invoice selection independent of the additional print-only materials.
export function mergeAlbaranMaterials(own = [], additional = []) {
  const seen = new Set();
  return [...own, ...(additional || [])].filter((line) => {
    const key = line.source_line_id || line.id;
    if (!key) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

// Cutting uses the stored numeric consumption as centimetres. This print-only
// total deliberately excludes waste and never feeds manufacturing/invoice costs.
export function cuttingMaterialTotals(material, garmentQuantity) {
  const garments = Number(garmentQuantity || 0);
  const consumptionCm = Number(material.quantity_per_unit || 0);
  return { garments, consumptionCm, totalCm: garments * consumptionCm };
}
